import moment from 'moment-timezone'
import { FC, useEffect, useState } from 'react'
import { Collapse } from 'antd'
import JobStatusProgressBar from '@OpsWb/components/JobStatusProgressBar/JobStatusProgressBar'
import { getCurrentMilestoneStage } from '@OpsWb/components/JobStatusProgressBar/logic'
import { ProgressDataType } from '@OpsWb/components/JobStatusProgressBar/types'
import styles from '@ProdWb/JobDetails/styles.css'

import colors from '~/styles/_colors.css'
import { JobRecordType } from '../../JobList/types'
import LocalStorageWrapper from '~/lib/LocalStorageWrapper'

import CollapsableHeaderSection from './CollapsableHeaderSection'

const { Panel } = Collapse

type JobProgressBarCollapsablePropsType = {
    progressData: ProgressDataType[]
    jobName: string
    jobId: number
    jobStatus: string
    pauseException: boolean | undefined
    exceptionCount: number
    jobDataForCreateException?: JobRecordType
    expandAll?: boolean
    isDownloadInspectionDocsBtnEnabled?: boolean
    jobRequestId?: number
}

const JobProgressBarCollapsable: FC<JobProgressBarCollapsablePropsType> = ({
    jobName,
    progressData,
    pauseException,
    jobId,
    jobStatus,
    exceptionCount,
    jobDataForCreateException,
    expandAll = false,
    isDownloadInspectionDocsBtnEnabled,
    jobRequestId,
}) => {
    const panelExpandedStateStorageKey = 'IS_JOB_TRACKER_EXPANDED'
    const storage = new LocalStorageWrapper()
    let isJobTrackerExpanded = '0'

    if (expandAll) {
        isJobTrackerExpanded = '1'
    } else {
        const rememberedActiveKey = storage.getItem(
            panelExpandedStateStorageKey,
        )

        isJobTrackerExpanded = rememberedActiveKey ? rememberedActiveKey : '0'
    }

    const [activeKey, setJobTrackerActiveKey] =
        useState<string>(isJobTrackerExpanded)

    useEffect(() => {
        setJobTrackerActiveKey(activeKey)
    }, [activeKey])

    const onExpandCollapse = () => {
        const updatedActiveKey = activeKey === '0' ? '1' : '0'

        setJobTrackerActiveKey(updatedActiveKey)
        storage.setItem(panelExpandedStateStorageKey, updatedActiveKey)
    }

    const currentStageIndex = getCurrentMilestoneStage(progressData) || null
    let isCurrentMilestoneOnTrack = true

    const currentData = currentStageIndex
        ? progressData[currentStageIndex]
        : undefined

    if (
        currentData?.committedDate &&
        moment(moment()).isAfter(currentData.committedDate)
    ) {
        isCurrentMilestoneOnTrack = false
    }

    return (
        <Collapse
            className={styles.collapseStyle}
            expandIconPosition="right"
            defaultActiveKey={activeKey}
            onChange={expandAll ? undefined : onExpandCollapse}
        >
            <Panel
                style={{ background: colors.white }}
                header={
                    <CollapsableHeaderSection
                        exceptionCount={exceptionCount}
                        jobName={jobName}
                        jobStatus={jobStatus}
                        pauseException={pauseException}
                        jobId={jobId}
                        isCurrentMilestoneOnTrack={isCurrentMilestoneOnTrack}
                        currentData={currentData}
                        jobDataForCreateException={jobDataForCreateException}
                        isDownloadInspectionDocsBtnEnabled={
                            isDownloadInspectionDocsBtnEnabled
                        }
                        jobRequestId={jobRequestId}
                    />
                }
                key="1"
            >
                <JobStatusProgressBar progressData={progressData} />
            </Panel>
        </Collapse>
    )
}

export default JobProgressBarCollapsable
